<template>
  <div class="teaching-schedule-query-clazz-arrange">
    <PlatDataPanelSelect custom-type="arrange"
                         :custom-id="customId"
                         :data-types="['semester']"
                         :border="false"
                         semesterLabel="选择学期">
      <template #default="scope">
        <TeachingScheduleQueryClazzArrangeMain :key="scope.semester"
                                               :clazz-id="rowData.id"
                                               :extra-params="scope"
                                               v-bind="$attrs"></TeachingScheduleQueryClazzArrangeMain>
      </template>
      <template #extra="scope">
        <action-form :action="$contextPath('/workspace/manager/teaching/schedule/query/clazz/exportArrange')"
                     :pre-handle-params="paramResolver"
                     :form-params="scope"
                     target="_blank">
          <template #default="{submit}">
            <el-button size="mini"
                       type="primary"
                       plain
                       @click="submit">导出班级课表</el-button>
          </template>
        </action-form>
      </template>
    </PlatDataPanelSelect>
  </div>
</template>

<script>
import PlatDataPanelSelect from '../../../../../wrapper/panel/PlatDataPanelSelect'
import TeachingScheduleQueryClazzArrangeMain from './main'
import routeConfig from '../../../../../../../../../constants/routeConfig'
export default {
  name: 'TeachingScheduleQueryClazzArrange',
  components: {
    PlatDataPanelSelect,
    TeachingScheduleQueryClazzArrangeMain
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      customId: ''
    }
  },
  methods: {
    paramResolver () {
      return {
        postId: this.rowData.id
      }
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataGrid.param]
  }
}
</script>

<style lang="scss">
  .teaching-schedule-query-clazz-arrange {
    height: 100%;
  }
</style>
